// 락업은 마스터 SVG(frontend/easy-air-screen/brand/)를 esbuild 임포트로 그대로 쓴다.
// 워드마크가 path 로 굳어 있어 폰트를 안 받아도 로고가 깨지지 않는다.
// 임포트 경유라 파일명에 내용 해시가 붙는다 — /brand/ 고정 경로는 nginx 가
// immutable 1년 캐시로 서빙해 로고를 바꿔도 브라우저가 옛것을 계속 썼다 (2026-08-10 실측).
import logoLight from '../../../brand/logo.svg'
import logoDark from '../../../brand/logo-dark.svg'

/** 배경에 따라 워드마크 색이 달라 두 파일을 CSS(.logo-light/.logo-dark)로 갈아 끼운다. */
export function Logo({ className = '' }: { className?: string }) {
  return (
    <>
      <img src={logoLight} alt="Easy Air Screen" className={`logo-light ${className}`} />
      <img src={logoDark} alt="" aria-hidden className={`logo-dark ${className}`} />
    </>
  )
}
